// import svgIcon from './SvgIcon/index.vue'
// 全局注册组件
const plugins = {
  // 注册
  install (Vue) {
    // Vue.component('svgIcon', svgIcon) // 第一个参数:组件名称,第二个参数:要注册的组件
  }
}
export default plugins
